const validate = values => {
    const errors = {intervalo: ''};
    if(!values.intervalo){
        errors.intervalo = 'Seleccione un rango de fechas';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/rechazos/validate.ts